import AccountSubscriptionFunctionalityModel from '@models/account/AccountSubscriptionFunctionalityModel';
import FunctionalityModel                    from '@models/account/FunctionalityModel';
import SubscriptionFunctionalityModel        from '@models/account/SubscriptionFunctionalityModel';
import appStore                              from '@/stores/appStore';
import createFunctionality                   from './engine/createFunctionality';
import { FUNCTIONALITIES }                   from './dictionary';
import { renderUpgradePrompt }               from './openUpgradePrompt';
import type { FunctionalityLimitReferenceOf }   from './engine/types';
import type { FunctionalityFeatureReferenceOf } from './engine/types';
import type { FunctionalityContextOf }          from './engine/types';
import type { FunctionalityQueryOf }            from './engine/types';
import type { FunctionalityValueOf }            from './engine/types';
import type { FunctionalityChangeOf }           from './engine/types';
import type { FunctionalityComparisonOf }       from './engine/types';
import type { FunctionalityLockMarkProps }      from './engine/types';

/**
 * Instanciation du moteur générique (./engine, sans dépendance au projet) avec la
 * configuration du backoffice : son dictionnaire, sa notion de session (appStore)
 * et son modèle de valeurs d'abonnement.
 */
const { FunctionalityGate, FunctionalityLockMark, functionalityStore } = createFunctionality({
	accountValueModel: AccountSubscriptionFunctionalityModel,
	functionalities: FUNCTIONALITIES,
	getAccount: () => appStore.account,
	planValueModel: SubscriptionFunctionalityModel,
	referentialModel: FunctionalityModel,
	renderBlockedDetails: renderUpgradePrompt,
});

export default FunctionalityGate;
export { FunctionalityLockMark };
export { functionalityStore };
export { FUNCTIONALITIES };

export type FunctionalityDictionary = typeof FUNCTIONALITIES;
export type FunctionalityLimitReference = FunctionalityLimitReferenceOf<FunctionalityDictionary>;
export type FunctionalityFeatureReference = FunctionalityFeatureReferenceOf<FunctionalityDictionary>;
export type FunctionalityContext<R extends FunctionalityLimitReference> = FunctionalityContextOf<FunctionalityDictionary, R>;
export type FunctionalityQuery<R extends FunctionalityLimitReference = FunctionalityLimitReference> = FunctionalityQueryOf<FunctionalityDictionary, R>;
export type FunctionalityValue = FunctionalityValueOf<FunctionalityDictionary>;
export type FunctionalityChange = FunctionalityChangeOf<FunctionalityDictionary>;
export type FunctionalityComparison = FunctionalityComparisonOf<FunctionalityDictionary>;
export type FunctionalityLockMarkQuery = FunctionalityLockMarkProps<FunctionalityDictionary>;
